import React, { ChangeEvent, FC } from 'react';
import { Grid, MenuItem, Select, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { PostShareStatus, SearchPostsFilter } from 'api';

interface Props {
  filters: SearchPostsFilter;
  setFilters: (filters: SearchPostsFilter) => void;
}

const Shared: FC<Props> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  function onChange(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    setFilters({ ...filters, share_status: value as PostShareStatus });
  }

  return (
    <Grid container alignItems="center">
      <Grid item xs={3}>
        <Typography variant="body2">{t('common:Shared')}</Typography>
      </Grid>

      <Grid item xs={4}>
        <Select fullWidth value={filters.share_status} onChange={onChange}>
          <MenuItem value={PostShareStatus.AllPosts}>{t('admin:allPosts')}</MenuItem>
          <MenuItem value={PostShareStatus.AlreadyShared}>{t('search:alreadyShared')}</MenuItem>
          <MenuItem value={PostShareStatus.NotShared}>{t('search:notShared')}</MenuItem>
        </Select>
      </Grid>
    </Grid>
  );
};

export default Shared;
